import { callbackMethods } from '../../constants';

export const callbackMethodOptions = callbackMethods?.map((item) => ({
  label: item,
  value: item,
}));

export const redirects = [
  {
    name: 'Complete URL',
    label: 'complete',
  },
  {
    name: 'Terminate URL',
    label: 'terminate',
  },
  {
    name: 'Security Terminate URL',
    label: 'securityTerminate',
  },
  {
    name: 'Quota Full URL',
    label: 'quotaFull',
  },
];
